import { render, staticRenderFns } from "./ExTable.vue?vue&type=template&id=231fb8f5&"
import script from "./ExTable.vue?vue&type=script&lang=js&"
export * from "./ExTable.vue?vue&type=script&lang=js&"
import style0 from "./ExTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports